{
  "name": "Majik CRM",
  "shortName": "Majik",
  "tagline": "The Majik Cleaning workspace.",
  "accent": "#2563EB",
  "mark": "/brand/mark.png",
  "fonts": {
    "display": "Inter",
    "ui": "Inter"
  },
  "email": {
    "canvas": "#FAFAF8",
    "surface": "#FFFFFF",
    "text": "#1A1A1A",
    "muted": "#6B6B6B",
    "faint": "#8A8A86",
    "divider": "#DEDBD3"
  },
  "testMode": false,
  "webhooks": false,
  "user": {
    "name": "Gideon Harris",
    "email": "buildsbygideon@gmail.com",
    "initials": "GH",
    "role": "Admin"
  },
  "base": {
    "name": "Apple-inspired web app base",
    "version": "1.0.0"
  }
}
